export default "__VITE_ASSET__BvubIs1G__"